import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const Register = () => {
  useEffect(() => {
    document.documentElement.classList.add('register-page');
    return () => {
      document.documentElement.classList.remove('register-page');
    };
  }, []);

  return (
    <>
      <div className="p-4 flex flex-col items-start max-w-sm mx-auto h-auto overflow-hidden pt-20 mb-20">
        <div className="flex items-center w-full py-8 border-b border-border/80">
          <Link to="/" className="flex items-center gap-x-2">
            <h1 className="text-lg font-medium">Stores for ecommerce</h1>
          </Link>
        </div>

        <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
          <h2 className="text-2xl font-semibold">Account creation now happens in MyPursePay</h2>
          <div className="w-full rounded-lg border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
            <p>Customer sign-up is handled directly through the MyPursePay app or dashboard. Once your MyPursePay profile is created, you can come back here and sign in with the same credentials.</p>
            <p className="mt-3">Need help? Reach out to the MyPursePay support team and they&apos;ll get you started.</p>
          </div>
        </div>

        <div className="flex flex-col items-start w-full mt-4">
          <p className="text-sm text-muted-foreground">
            Already set up with MyPursePay?{' '}
            <Link to="/login" className="text-primary">
              Sign in instead
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;